export default __webpack_public_path__ + "static/media/banner-1197x319-baked-bread.f9f26956.jpg";